import React, { Component, Suspense } from "react";

import ViewContentWindow from "./Views/Learn/ViewContentWindow";
import LoginScreen from "./Views/Login/LoginScreen";
import { Route, Switch } from "react-router"; // react-router v4/v5
import { ConnectedRouter } from "connected-react-router";

import { history } from "./Redux/store";
import LoginCheck from "./LoginCheck";
import HubBridge from "./Views/HubBridge";
import Loading from "./Views/Admin/Components/Loading";
import NotFound from "./Views/Admin/Components/NotFound";
import LoginError from "./Views/Admin/Components/LoginError";
import ErrorBoundary from "./Views/Admin/Components/ErrorBoundary";

const AdminView = React.lazy(() => import("./Views/Admin/AdminView"));
const TestHome = React.lazy(() => import("./Views/Test/TestHome"));
const HelpList = React.lazy(() => import("./Views/Learn/HelpList"));
const HelpCenter = React.lazy(() => import("./Views/Learn/HelpCenter"));

class Routes extends Component {
  render() {
    return (
      <ConnectedRouter history={history}>
        {/* #337: root error boundary. A render-time throw in LoginCheck or any
            routed view now renders the Error fallback (with a reload action)
            instead of a blank white screen. */}
        <ErrorBoundary title="Something went wrong">
          <LoginCheck />
          {/* Digadop 2.0: hub embed session + navigation bridge (no-op unless
              ?embedded=hub). Mounted alongside LoginCheck so a hub-posted
              session lands before the routed views render. */}
          <HubBridge />
          <Switch>
          <Route exact path="/" component={Loading} />
          <Route path="/login/error" component={LoginError} />
          <Route path="/login" component={LoginScreen} />
          <Suspense
            path="/learn"
            fallback={<Loading message="Loading Help Panel" />}
          >
            <Route path="/learn" component={HelpList} />
          </Suspense>
          <Suspense
            path="/helpcenter"
            fallback={<Loading message="Loading Help Center" />}
          >
            <Route path="/helpcenter" component={HelpCenter} />
          </Suspense>
          <Suspense
            path="/test"
            fallback={<Loading message="Loading Testing Application" />}
          >
            <Route path="/test/:testID" component={TestHome} />
          </Suspense>
          <Route
            path="/view/:layoutID/:contentID"
            component={ViewContentWindow}
          />
          <Suspense
            path="/admin"
            fallback={<Loading message="Loading Admin Panel" />}
          >
            <Route path="/admin" component={AdminView} />
          </Suspense>

            <Route component={NotFound} />
          </Switch>
        </ErrorBoundary>
      </ConnectedRouter>
    );
  }
}

export default Routes;
